// src/components/ErrorBoundary.js
import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to console in development, but don't crash the app
    console.error('ErrorBoundary caught an error:', error, errorInfo);

    // Only log React DOM manipulation warnings in development
    if (process.env.NODE_ENV === 'development' &&
        (error.message?.includes('removeChild') || error.message?.includes('insertBefore'))) {
      console.warn('React DOM manipulation warning detected (this is a development-only warning):', error);
      return;
    }

    // For other errors, set the full error info
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      // For React DOM warnings, render children normally (they're working fine)
      if (this.state.error?.message?.includes('removeChild') ||
          this.state.error?.message?.includes('insertBefore')) {
        return this.props.children;
      }

      // For other errors, show error message
      return (
        <div style={{ padding: '20px', border: '1px solid #ff6b6b', borderRadius: '8px', margin: '20px' }}>
          <h2 style={{ color: '#d63031' }}>Something went wrong</h2>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo.componentStack}
          </details>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;